export interface DataGenMarkProps {
  /** Icon size in px (also drives the wordmark size). */
  size?: number;
}

/**
 * DataGen lockup: icon + "DataGen" wordmark.
 * Faithful to the original SVG — same icon geometry, same wordmark font
 * (system-ui, weight 800, -0.5px letter-spacing). Strokes/fills use
 * currentColor so the lockup inherits the surrounding text colour and
 * works on light and dark surfaces.
 */
export function DataGenMark({ size = 36 }: DataGenMarkProps) {
  // Original wordmark sits at 22px font-size next to a 40px icon — keep
  // the same proportion so any caller-supplied `size` scales correctly.
  const labelSize = Math.round(size * 0.55);
  return (
    <span
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: Math.max(6, Math.round(size * 0.22)),
        lineHeight: 1,
        userSelect: 'none',
      }}
      aria-label="DataGen"
    >
      <svg
        width={size}
        height={size}
        viewBox="0 0 40 40"
        fill="none"
        aria-hidden="true"
      >
        <circle
          cx="20"
          cy="19"
          r="18"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          opacity="0.9"
        />
        <g transform="translate(8, 7)">
          <circle
            cx="12"
            cy="12"
            r="3.5"
            fill="currentColor"
            stroke="currentColor"
            strokeWidth="1"
          />
          <path
            d="M12 2 L12 8.5 M12 15.5 L12 22 M2 12 L8.5 12 M15.5 12 L22 12"
            stroke="currentColor"
            strokeWidth="3"
            strokeLinecap="round"
          />
          <circle cx="6" cy="6" r="2" fill="currentColor" />
          <circle cx="18" cy="6" r="2" fill="currentColor" />
          <circle cx="6" cy="18" r="2" fill="currentColor" />
          <circle cx="18" cy="18" r="2" fill="currentColor" />
          <path
            d="M9.5 9.5 L6 6 M14.5 9.5 L18 6 M9.5 14.5 L6 18 M14.5 14.5 L18 18"
            stroke="currentColor"
            strokeWidth="2.5"
            strokeLinecap="round"
          />
          <path
            d="M12 5 L12 6.5 M12 17.5 L12 19 M5 12 L6.5 12 M17.5 12 L19 12"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
          />
        </g>
      </svg>
      <span
        style={{
          fontFamily:
            "system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
          fontWeight: 800,
          fontSize: labelSize,
          letterSpacing: '-0.5px',
          color: 'currentColor',
          lineHeight: 1,
        }}
      >
        DataGen
      </span>
    </span>
  );
}
